export default __webpack_public_path__ + "static/media/Hz396.adbb57f2.mp3";